import React from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled";


const ButtonWrapper = styled.button`
    width: fit-content;
    height: 36px;
    padding: 0 16px;
    
    /* default/shade/white */
    /* default/gray/400 */
    user-select: none;
    cursor:pointer;
    
    border: 1px solid #4A5568;
    box-sizing: border-box;
    border-radius: 4px;
 
    background: #FFFFFF center;
    transition: background 0.8s;
    
    :hover {
      background: rgba(118,118,117,0.28) radial-gradient(circle, transparent 1%, rgba(118,118,117,0.17) 1%) center/15000%;
    }
    
    :active {
      background-color: #767675;
      background-size: 100%;
      transition: background 0s;
    }
    
    :focus {
        outline: none
    }
    
    /* text-base/Regular */
    font-family: Metropolis;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    text-space: 16px;
    /* identical to box height, or 100% */
    
    /* default/gray/700 */
    color: var(--color-gray-700);
`;

function ActionButton4(props) {
    return (
        <ButtonWrapper onClick={props.onClick}>
            {props.children}
        </ButtonWrapper>
    );
}

ActionButton4.propTypes = {};
ActionButton4.defaultProps = {};

export default ActionButton4;
